import { render, staticRenderFns } from "./PhoneNumbersPropertyEditModal.vue?vue&type=template&id=2bbbe2d1"
import script from "./PhoneNumbersPropertyEditModal.vue?vue&type=script&lang=js"
export * from "./PhoneNumbersPropertyEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports